import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import VSwitch from "v-switch-case";
/* import LyraForm from "@lyracom/vue-embedded-form" */

Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.use(VSwitch);

/* const setup = {
  'kr-client-domain': process.env.VUE_APP_PAYZEN_END_POINT,
  'kr-theme': 'material',
  'kr-public-key': process.env.VUE_APP_PAYZEN_PUBLIC_KEY
};

Vue.use(LyraForm, setup);
 */
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
